import React from "react";
import Button from "../Button";
import UploadInput from "../Inputs/UploadInput";

const DownloadCard = ({
  disabled = false,
  className = "",
  title = "Download your Agreement",
  buttonText = "Download",
  onClick,
  download = true,
  onFileUpload,
  selectedFile,
}) => {
  return (
    <div
      className={`flex flex-col bg-background_2/80 w-full md:w-1/3 gap-4 px-2 py-8 rounded-2xl justify-center items-center h-48 ${className}`}
    >
      <h2
        className={`text-headline5 font-nunito font-semibold ${
          disabled ? "text-secondary/60" : "text-secondary/90"
        }`}
      >
        {title}
      </h2>

      {download ? (
        <Button
          size="sm"
          variant="default"
          disabled={disabled}
          onClick={onClick}
          className={`flex items-center justify-center gap-2 ${
            disabled
              ? "bg-secondary/20 cursor-not-allowed"
              : "bg-primary text-white hover:bg-primary-dark"
          }`}
        >
          {buttonText}
        </Button>
      ) : selectedFile ? (
        <div className="flex justify-center gap-2 items-center line-clamp-1">
          <Button size="sm" variant="default" onClick={onClick}>
            Upload
          </Button>
          <p className="text-sm text-secondary/60 line-clamp-1">
            Uploaded {selectedFile.name}
          </p>
        </div>
      ) : (
        <UploadInput
          placeholder="Upload CSV"
          disabled={disabled}
          onChange={onFileUpload}
          hideLabels={true}
          accept=".csv"
          className="cursor-pointer"
        />
      )}
    </div>
  );
};

export default DownloadCard;
